import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromLogin from '@features/login/reducers/login.reducer';
import { login } from '@features/login/actions/login.actions';
import { startSession } from '@features/login/actions/start-session.actions';
import { StartSession } from '@shared/models/start-session';
import { setPassword } from '@features/set-password/actions/set-password.actions';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(private store: Store) {}

  login(email: string, password: string): void {
    this.store.dispatch(login({ email, password }));
  }

  startSession(session: StartSession): void {
    this.store.dispatch(startSession({ data: session }));
  }

  setPassword(token: string, password: string): void {
    this.store.dispatch(setPassword({ token: token, password: password }));
  }

  getAccessToken(): Observable<string> {
    return this.store.select(fromLogin.selectAccessToken);
  }

  getMfaActive(): Observable<boolean> {
    return this.store.select(fromLogin.selectMfaActive);
  }

  getLoginLoading(): Observable<boolean> {
    return this.store.select(fromLogin.selectLoginLoading);
  }
}
